module.exports = __webpack_public_path__ + "img/screenshot_new15.23cf37bf.png";